import { render, staticRenderFns } from "./TheDocument.vue?vue&type=template&id=7b276c98&scoped=true&"
import script from "./TheDocument.vue?vue&type=script&lang=js&"
export * from "./TheDocument.vue?vue&type=script&lang=js&"
import style0 from "./TheDocument.vue?vue&type=style&index=0&id=7b276c98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b276c98",
  null
  
)

export default component.exports